import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styles from './TopNavigationBar.module.scss';

export const TopNavigationBar = () => {
    const isAuthenticated = useSelector(state => state.authentication.isAuthenticated);

    // Only show the top bar when user is authenticated
    if (!isAuthenticated) {
        return null;
    }

    return (
        <div className={styles['top-navigation-bar']}>
            <div className={styles['top-nav-content']}>
                <div className={styles['logo-section']}>
                    <Link
                        to="/"
                        className={styles['logo-link']}
                        aria-label="Go to homepage"
                        title="Go to homepage"
                    >
                        <img
                            src="/logo/PRISM.png"
                            alt="Company Logo"
                            className={styles['company-logo']}
                        />
                    </Link>
                </div>
                <div className={styles['nav-actions']}>
                </div>
            </div>
        </div>
    );
};
